import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { RouteError } from "@/shared/components/RouteError";
import { RoutePending } from "@/shared/components/RoutePending";

export const Route = createFileRoute("/app/admin/notification-channels")({
  beforeLoad: ({ context }) => {
    // BEL-760: platform-plane module — gates on platformAdmin, never on a
    // CASL permission. A customer role can hold settings.customers in
    // production, which would let it reach a screen listing every
    // customer's webhook config/credentials.
    if (context.auth.user?.platformAdmin !== true) {
      throw redirect({ to: "/app" });
    }
  },
  component: Outlet,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
